import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloPlannerEnabledCalendarsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloPlannerEnabledCalendars"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloMember","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloPlannerEnabledCalendars","document":TrelloPlannerEnabledCalendarsDocument}} as const;
export type TrelloPlannerEnabledCalendarsQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type TrelloPlannerEnabledCalendarsQuery = (
  { __typename: 'Query' }
  & { trello: (
    { __typename: 'TrelloQueryApi' }
    & { member?: Types.Maybe<(
      { __typename: 'TrelloMember' }
      & Pick<Types.TrelloMember, 'id'>
      & { planner?: Types.Maybe<(
        { __typename: 'TrelloPlanner' }
        & Pick<Types.TrelloPlanner, 'id'>
        & { accounts?: Types.Maybe<(
          { __typename: 'TrelloPlannerCalendarAccountConnection' }
          & { edges?: Types.Maybe<Array<(
            { __typename: 'TrelloPlannerCalendarAccountEdge' }
            & { node?: Types.Maybe<(
              { __typename: 'TrelloPlannerCalendarAccount' }
              & Pick<Types.TrelloPlannerCalendarAccount, 'id'>
            )> }
          )>> }
        )> }
      )> }
    )> }
  ) }
);

/**
 * __useTrelloPlannerEnabledCalendarsQuery__
 *
 * To run a query within a React component, call `useTrelloPlannerEnabledCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloPlannerEnabledCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloPlannerEnabledCalendarsQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useTrelloPlannerEnabledCalendarsQuery(
  baseOptions: TrelloQueryHookOptions<
    TrelloPlannerEnabledCalendarsQuery,
    TrelloPlannerEnabledCalendarsQueryVariables
  > &
    (
      | {
          variables: TrelloPlannerEnabledCalendarsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TrelloPlannerEnabledCalendarsDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TrelloPlannerEnabledCalendarsQuery,
    TrelloPlannerEnabledCalendarsQueryVariables
  >(TrelloPlannerEnabledCalendarsDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTrelloPlannerEnabledCalendarsLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TrelloPlannerEnabledCalendarsQuery,
    TrelloPlannerEnabledCalendarsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TrelloPlannerEnabledCalendarsQuery,
    TrelloPlannerEnabledCalendarsQueryVariables
  >(TrelloPlannerEnabledCalendarsDocument, options);
}
export function useTrelloPlannerEnabledCalendarsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TrelloPlannerEnabledCalendarsQuery,
        TrelloPlannerEnabledCalendarsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TrelloPlannerEnabledCalendarsQuery,
    TrelloPlannerEnabledCalendarsQueryVariables
  >(TrelloPlannerEnabledCalendarsDocument, options);
}
export type TrelloPlannerEnabledCalendarsQueryHookResult = ReturnType<
  typeof useTrelloPlannerEnabledCalendarsQuery
>;
export type TrelloPlannerEnabledCalendarsLazyQueryHookResult = ReturnType<
  typeof useTrelloPlannerEnabledCalendarsLazyQuery
>;
export type TrelloPlannerEnabledCalendarsSuspenseQueryHookResult = ReturnType<
  typeof useTrelloPlannerEnabledCalendarsSuspenseQuery
>;
export type TrelloPlannerEnabledCalendarsQueryResult = Apollo.QueryResult<
  TrelloPlannerEnabledCalendarsQuery,
  TrelloPlannerEnabledCalendarsQueryVariables
>;
